import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Facebook, Instagram, Mail, Trophy } from "lucide-react";
export default function Kontakt() {
  const quickLinks = [{
    label: "O obozie",
    href: "#o-obozie"
  }, {
    label: "Program",
    href: "#program"
  }, {
    label: "Galeria",
    href: "#galeria"
  }, {
    label: "Kontakt",
    href: "#kontakt"
  }];
  const socialLinks = [{
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Facebook,
    href: "https://www.facebook.com/people/Dawid-Kasperski/100041220231054/",
    label: "Facebook"
  }, {
    icon: Trophy,
    href: "https://www.tapology.com/fightcenter/fighters/104695-dawid-kasperski",
    label: "Tapology"
  }];
  return <section id="kontakt" className="dark bg-background text-foreground pt-16 pb-8 px-4 md:px-8 border-t border-border">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {}
          <div className="flex flex-col items-start">
            <Link href="/" className="mb-6 inline-block">
              <img src="https://newwavecamp.com/wp-content/uploads/2026/03/IMG_7243-1-scaled-e1773607445434.jpg" alt="New Wave Camp Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              Elitarny obóz sportowy na Koh Samui. Trenuj z profesjonalistami,
              przekraczaj własne granice i doświadcz niezapomnianej przygody w
              tropikalnym raju.
            </p>
          </div>

          {}
          <div className="flex flex-col md:items-center">
            <div>
              <h3 className="text-lg font-bold uppercase tracking-wider mb-6">
                Na skróty
              </h3>
              <ul className="space-y-3">
                {quickLinks.map((link, i) => <li key={link.label} data-index={i}>
                    <Link to={link.href} className="text-muted-foreground hover:text-primary transition-colors text-sm uppercase tracking-wide">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>
          </div>

          {}
          <div className="flex flex-col md:items-end">
            <div className="w-full md:w-auto">
              <h3 className="text-lg font-bold uppercase tracking-wider mb-6 md:text-right">
                Bądź w kontakcie
              </h3>
              <div className="flex flex-col gap-3 mb-6 md:items-end">
                <div className="flex flex-col md:items-end">
                  <p className="text-sm font-semibold text-muted-foreground md:text-right">
                    Dawid Kasperski
                  </p>
                  <p className="text-xs italic text-white md:text-right">
                    Główny Trener
                  </p>
                </div>
                <img src="https://newwavecamp.com/wp-content/uploads/2026/03/630142257_18379299595095949_678308900264550416_n.jpg" alt="Dawid Kasperski" className="h-14 w-auto object-contain rounded-md self-start md:self-auto" />
              </div>
              <div className="flex gap-4 mb-6 md:justify-end">
                {socialLinks.map((social, i) => {
                const Icon = social.icon;
                return <Link key={social.label} to={social.href} newTab={social.href.startsWith("http")} className="bg-muted hover:bg-primary hover:text-primary-foreground text-muted-foreground p-2.5 rounded-full transition-all duration-300" aria-label={social.label} data-index={i}>
                      <Icon className="size-5" />
                    </Link>;
              })}
              </div>
              <div className="flex items-center gap-3 md:justify-end group">
                <div className="bg-primary/10 p-2 rounded-full group-hover:bg-primary/20 transition-colors">
                  <Mail className="size-4 text-primary" />
                </div>
                <Link to="mailto:kontat@newwavecamp.com" className="text-primary font-medium hover:text-primary/80 transition-colors">kontakt@newwavecamp.com</Link>
              </div>
            </div>
          </div>
        </div>

        <Separator className="mb-8 bg-border/50" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground">
          <p>
            &copy; {new Date().getFullYear()} NowaFala. Wszelkie prawa
            zastrzeżone.
          </p>
          <p className="uppercase tracking-widest font-semibold text-foreground/60">
            Zaprojektowane dla Mistrzów
          </p>
        </div>
      </div>
    </section>;
}